<template>
	<div>




		<h2>
			Tags.1
		</h2>
		<div class="row">
			<div class="col-xs-12">
				<NbTag
					:tags="tags"
					@tags-change="handleChange"></NbTag>
			</div>
			<div class="col-xs-12">
				{{tags}}
			</div>

		</div>
	</div>

</template>
<script>

	import NbTag from "../../../common/widget/NbTag.vue";
	export default{
		data(){
			return {

				tags: ["人生", "这里"]
			}
		},
		watch: {},
		methods: {
			handleChange(){
			}
		},
		components: {
			NbTag
		},
		mounted(){

		}
	}
</script>



// WEBPACK FOOTER //
// NbTagDemo.vue?8fc789e0